import api from '@/lib/api';
import type {
  ApiResponse,
  PaginationMeta,
  SubscriptionResponse,
  CreateCheckoutRequest,
  CreateCheckoutResponse,
  CreatePortalRequest,
  CreatePortalResponse,
  TenantInvoice,
  PurchaseSmsCreditsRequest,
} from '@amuster/types';

export const billingService = {
  getSubscription() {
    return api.get<ApiResponse<SubscriptionResponse>>('/billing/subscription');
  },

  createCheckout(data: CreateCheckoutRequest) {
    return api.post<ApiResponse<CreateCheckoutResponse>>('/billing/checkout', data);
  },

  createPortal(data: CreatePortalRequest) {
    return api.post<ApiResponse<CreatePortalResponse>>('/billing/portal', data);
  },

  getInvoices(query?: { page?: number; limit?: number }) {
    return api.get<ApiResponse<TenantInvoice[]> & { meta: PaginationMeta }>('/billing/invoices', { params: query });
  },

  purchaseSmsCredits(data: PurchaseSmsCreditsRequest) {
    return api.post<ApiResponse<{ balance: number }>>('/billing/sms-credits', data);
  },
};
